module.exports = __webpack_public_path__ + "static/media/canaldemiitalic.d06a59fa.woff2";